"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeDetailsLayout = exports.ChallengeDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var main_aside_1 = require("../elements/main-aside");
var entity_value_1 = require("./entity-value");
var link_1 = require("../elements/link");
var entity_link_value_1 = require("./entity-link-value");
var entity_list_1 = require("./entity-list");
var entity_list_section_1 = require("./entity-list-section");
var grid_1 = require("../elements/grid");
var key_issue_card_1 = require("./key-issue-card");
var target_row_1 = require("./target-row");
var taxonomy_entity_expertise_1 = require("./taxonomy-entity-expertise");
var taxonomy_entity_incoming_lists_1 = require("./taxonomy-entity-incoming-lists");
exports.ChallengeDetailsLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", ";\n  "], ["\n    padding: ", " ", " ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.H_DOT_BG_END())
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var KeyIssueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    padding: 0;\n    padding-bottom: ", ";\n  "], ["\n    border-top: 1px solid ", ";\n    padding: 0;\n    padding-bottom: ", ";\n  "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(4))
});
var AboutSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ExpertiseStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    &:first-child {\n      padding-top: ", ";\n    }\n  "], ["\n    &:first-child {\n      padding-top: ", ";\n    }\n  "])), theme_1.theme.UNIT(4))
});
var IncomingListsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  AboutSection: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), AboutSectionStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  KeyIssue: (0, styled_components_1.default)(key_issue_card_1.KeyIssueCard)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), KeyIssueStyles),
  Expertise: (0, styled_components_1.default)(taxonomy_entity_expertise_1.TaxonomyEntityExpertise)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ExpertiseStyles),
  IncomingLists: (0, styled_components_1.default)(taxonomy_entity_incoming_lists_1.TaxonomyEntityIncomingLists)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), IncomingListsStyles)
};
var ChallengeDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    banner = props.banner;
  var description = entity.description,
    curator = entity.curator,
    _a = entity.keyIssues,
    keyIssues = _a === void 0 ? [] : _a,
    _b = entity.indicators,
    indicators = _b === void 0 ? [] : _b,
    _c = entity.dataSets,
    dataSets = _c === void 0 ? [] : _c,
    _d = entity.targets,
    targets = _d === void 0 ? [] : _d;
  var hasDataSets = !!dataSets.length;
  var hasTargets = !!targets.length;
  var hasIndicators = !!indicators.length;
  var hasData = hasIndicators || hasDataSets || hasTargets;
  var hasKeyIssues = !!keyIssues.length; //; && !!find(keyIssues, keyIssue => !!(keyIssue.description && keyIssue.description.html));
  var hasDescription = description && description.text;
  var hasAside = asideHeader || hasData || asideFooter;
  return react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(My.MainAside, {
    main: react_1.default.createElement(My.Main, null, mainHeader, hasDescription && react_1.default.createElement(My.AboutSection, {
      title: "About:"
    }, react_1.default.createElement(My.Description, {
      entity: description
    })), !!curator && react_1.default.createElement(My.Section, {
      title: "Curator:"
    }, react_1.default.createElement(My.LinkValue, {
      entity: curator
    })), react_1.default.createElement(My.Expertise, {
      entity: entity
    }), react_1.default.createElement(My.IncomingLists, {
      entity: entity
    }), hasKeyIssues && react_1.default.createElement(My.Section, {
      title: "{{KEY_ISSUES}}:"
    }, keyIssues.map(function (keyIssue) {
      return react_1.default.createElement(My.KeyIssue, {
        key: keyIssue.id,
        entity: keyIssue
      });
    })), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, hasData && react_1.default.createElement(My.Section, {
      title: "Data Sets and Targets:"
    }, react_1.default.createElement(My.List, {
      showDividers: true,
      rowComponent: target_row_1.TargetRow,
      showDescription: true,
      showDividerForLast: hasTargets || hasDataSets,
      useLinks: false,
      items: indicators
    }), react_1.default.createElement(My.List, {
      showDividers: true,
      variant: "card",
      showDividerForLast: hasTargets,
      padFirst: hasIndicators,
      useLinks: false,
      items: dataSets
    }), react_1.default.createElement(My.List, {
      showDividers: true,
      rowComponent: target_row_1.TargetRow,
      padFirst: hasDataSets || hasIndicators,
      useLinks: false,
      items: targets
    })), asideFooter)
  }));
};
exports.ChallengeDetailsLayout = ChallengeDetailsLayout;
exports.ChallengeDetailsLayout.defaultProps = exports.ChallengeDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33;